import React, { FC } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components';

const useStyles = makeStyles()(() => ({
  paper: {
    background: 'rgba(18, 17, 17, 1)',
    boxShadow: '4px -4px 8px rgba(0, 0, 0, 0.4), -4px 4px 8px rgba(0, 0, 0, 0.4)',
    borderRadius: '12px',
    color: '#fff',
    maxWidth: '500px',
    border: '1px solid #FFBF00',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px 30px 30px 30px',
  },
  title: {
    padding: '20px 30px 10px 30px',
    textAlign: 'center',
    color: '#fff',
    fontSize: '18px',
    fontWeight: 600,
  },
}));

type WidgetTicketsAvailabilityPopupPropsType = {
  handleClose: () => void;
  open: boolean;
};

export const WidgetTicketsAvailabilityPopup: FC<WidgetTicketsAvailabilityPopupPropsType> = ({
  handleClose,
  open,
}) => {
  const { classes } = useStyles();

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      classes={{
        paper: classes.paper,
      }}
      slotProps={{
        backdrop: {
          sx: {
            background: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
          },
        },
      }}
    >
      <DialogTitle className={classes.title}>
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
      </DialogTitle>

      <DialogContent className={classes.content}>
        <Message>
          Only 11 tickets left at $88 each.
          <br />
          The next batch of tickets will be $110
        </Message>
      </DialogContent>
    </Dialog>
  );
};

const CloseButton = styled(IconButton)`
  position: absolute !important;
  right: 10px;
  top: 10px;
  color: #fff !important;
`;

const Message = styled.div`
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
`;

